import LwBankModal from './LwBankModal';

export default LwBankModal;
